(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["layout-height-variables"] && !Shopify.designMode) return;
  try {
    (function () {
    var TARGETS = [
      { id: 'shopify-section-announcement-bar', cssVar: '--announcement-bar-height' },
      { id: 'shopify-section-header', cssVar: '--header-height' }
    ];

    var heights = {};

    function updateTotal() {
      var total = 0;

      TARGETS.forEach(function (target) {
        total += heights[target.cssVar] || 0;
      });

      document.documentElement.style.setProperty('--header-total-height', total + 'px');
    }

    function setHeight(cssVar, value) {
      heights[cssVar] = value;
      document.documentElement.style.setProperty(cssVar, value + 'px');
      updateTotal();
    }

    function clearHeight(cssVar) {
      heights[cssVar] = 0;
      document.documentElement.style.removeProperty(cssVar);
      updateTotal();
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var target = TARGETS.filter(function (candidate) {
          return candidate.id === entry.target.id;
        })[0];

        if (target) {
          setHeight(target.cssVar, entry.target.clientHeight);
        }
      });
    });

    function observeTarget(target) {
      var element = document.getElementById(target.id);

      if (element) {
        resizeObserver.observe(element);
      } else {
        clearHeight(target.cssVar);
      }
    }

    function observeAll() {
      TARGETS.forEach(observeTarget);
    }

    observeAll();

    document.addEventListener('shopify:section:load', observeAll);

    document.addEventListener('shopify:section:unload', function (event) {
      var target = TARGETS.filter(function (candidate) {
        return candidate.id === 'shopify-section-' + event.detail.sectionId;
      })[0];

      if (target) {
        resizeObserver.unobserve(event.target);
        clearHeight(target.cssVar);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-estimated-delivery-timeline"] && !Shopify.designMode) return;
  try {
    (() => {
    const blockSelector = '.estimated-delivery-block__inner';

    const formatDate = (date) => {
      return date.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      });
    };

    const updateEstimatedDelivery = (root) => {
      if (!root) return;

      const mode = root.getAttribute('data-shipping-mode');
      const startOffset = parseInt(root.getAttribute('data-start-days') || '0', 10);
      const endOffset = parseInt(root.getAttribute('data-end-days') || '0', 10);

      const now = new Date();
      const startDate = new Date(now);
      const endDate = new Date(now);

      if (mode === 'within_24_48') {
        // 24–48 hours ≈ 1–2 days from now
        startDate.setDate(startDate.getDate() + 1);
        endDate.setDate(endDate.getDate() + 2);
      } else {
        startDate.setDate(startDate.getDate() + (isNaN(startOffset) ? 0 : startOffset));
        endDate.setDate(endDate.getDate() + (isNaN(endOffset) ? (isNaN(startOffset) ? 0 : startOffset) : endOffset));
      }

      const startTarget = root.querySelector('[data-estimated-start]');
      const endTarget = root.querySelector('[data-estimated-end]');

      if (startTarget) startTarget.textContent = formatDate(startDate);
      if (endTarget) endTarget.textContent = formatDate(endDate);
    };

    const init = () => {
      const roots = document.querySelectorAll(blockSelector);
      roots.forEach(updateEstimatedDelivery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-viewing"] && !Shopify.designMode) return;
  try {
    (function() {
    const blocks = document.querySelectorAll('.people-viewing');

    if (!blocks.length) return;

    blocks.forEach((block) => {
      const min = parseInt(block.dataset.min, 10) || 1;
      const max = parseInt(block.dataset.max, 10) || 10;
      const countSpan = block.querySelector('.people-viewing-count');

      if (!countSpan) return;

      const randomCount = Math.floor(Math.random() * (max - min + 1)) + min;
      countSpan.textContent = String(randomCount);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["revamp-currency-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    const selectorRoot = document.querySelector('[data-country-currency-selector]');
    if (!selectorRoot) return;

    const details = selectorRoot;
    const form = selectorRoot.querySelector('form');
    const select = selectorRoot.querySelector('[data-country-currency-select]');

    if (!form || !select) return;

    document.addEventListener('click', (event) => {
      if (!details.open) return;
      if (!selectorRoot.contains(event.target)) {
        details.open = false;
      }
    });

    select.addEventListener('change', () => {
      if (document.startViewTransition) {
        document.startViewTransition(() => {
          form.submit();
        });
      } else {
        form.submit();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
